"use strict";
//https://jsfiddle.net/2uc346hp/
Object.defineProperty(exports, "__esModule", { value: true });
exports.round_to_precision = exports.randn_bm = void 0;
const randn_bm = (min, max, skew) => {
    var u = 0, v = 0;
    while (u === 0)
        u = Math.random(); //Converting [0,1) to (0,1)
    while (v === 0)
        v = Math.random();
    let num = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
    num = num / 10.0 + 0.5; // Translate to 0 -> 1
    if (num > 1 || num < 0)
        num = (0, exports.randn_bm)(min, max, skew); // resample between 0 and 1 if out of range
    num = Math.pow(num, skew); // Skew
    num *= max - min; // Stretch to fill range
    num += min; // offset to min
    return num;
};
exports.randn_bm = randn_bm;
const round_to_precision = (x, precision) => {
    var y = +x + (precision === undefined ? 0.5 : precision / 2);
    return y - (y % (precision === undefined ? 1 : +precision));
};
exports.round_to_precision = round_to_precision;
